import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "product-detail-two",
  useLayout: true,
  children: [
    // {
    //     id: SectionsKey.Related,
    //     order: 0,
    //     dataKey: SectionsKey.Related + '_top'
    // },
    {
      id: SectionsKey.ProductDetailTwo,
      order: 1,
      dataKey: SectionsKey.ProductDetailTwo,
    },
    // {
    //     id: SectionsKey.ProductTags,
    //     order: 3,
    //     dataKey: SectionsKey.ProductTags
    // }
    {
      id: SectionsKey.FeaturedProductV2,
      order: 2,
      identifier: Identifiers.YouMayAlsoLike,
      dataKey: SectionsKey.FeaturedProductV2,
    },
    {
      id: SectionsKey.Related,
      order: 3,
      dataKey: SectionsKey.Related,
    },
    {
      id: SectionsKey.RecentlyView,
      order: 4,
      dataKey: SectionsKey.RecentlyView,
    },
    {
      id: SectionsKey.BenefitsSection,
      order: 4,
      identifier: Identifiers.BenefitsSection,
      dataKey: SectionsKey.BenefitsSection,
    },
    {
      id: SectionsKey.FollowUs,
      order: 5,
      identifier: Identifiers.FollowUs,
      dataKey: SectionsKey.FollowUs,
    },
  ],
};

export default PageStruct;
